import { Handshake, ChevronRight, CheckCircle2 } from "lucide-react";
import { STATUS_TONE, PIPELINE_BUCKETS, fmtDate } from "./portalStatus";
import { PortalEmptyState } from "./PortalJourney";

export const PortalPipeline = ({ referrals, stats, persona, onRefer, onOpen }) => {
  const counts = PIPELINE_BUCKETS.map((b) => ({
    ...b, count: b.statuses.reduce((n, s) => n + (stats.by_status?.[s] || 0), 0),
  }));
  return (
    <section id="referrals" className="bg-white rounded-2xl border border-slate-200 scroll-mt-6" data-testid="portal-pipeline">
      <div className="p-5 md:p-6 border-b border-slate-100 flex items-center justify-between gap-3">
        <h2 className="font-bold text-[#0A2342] flex items-center gap-2 text-base md:text-lg">
          <Handshake className="w-5 h-5 text-[#C8A96B]" /> Your Referral Progress
        </h2>
        {referrals.length > 0 && (
          <button onClick={onRefer} className="text-sm font-semibold text-[#0A2342] hover:text-[#C8A96B]" data-testid="portal-pipeline-refer-btn">+ {persona?.cta || "Refer Someone"}</button>
        )}
      </div>

      {referrals.length === 0 ? (
        <PortalEmptyState onRefer={onRefer} persona={persona} />
      ) : (
        <>
          <div className="p-5 md:p-6 grid grid-cols-3 sm:grid-cols-6 gap-2" data-testid="portal-pipeline-counts">
            {counts.map((c) => (
              <div key={c.key} className="rounded-xl bg-slate-50 border border-slate-100 px-2 py-3 text-center" data-testid={`portal-pipeline-${c.key}`}>
                <div className="text-xl font-bold text-[#0A2342]">{c.count}</div>
                <div className="text-[10px] uppercase tracking-wide text-slate-500 font-semibold">{c.label}</div>
              </div>
            ))}
          </div>
          <ul className="divide-y divide-slate-100" data-testid="portal-referrals-list">
            {referrals.map((r) => (
              <li key={r.id}>
                <button onClick={() => onOpen(r.id)} data-testid={`portal-referral-${r.id}`}
                  className="w-full text-left p-4 md:px-6 flex items-center justify-between gap-3 hover:bg-slate-50 transition-colors">
                  <div className="min-w-0">
                    <div className="font-semibold text-slate-900 truncate">{r.referral_name}</div>
                    <div className="text-xs text-slate-500 mt-0.5 truncate">
                      Submitted {fmtDate(r.created_at)}
                      {r.preferred_neighborhood ? ` · ${r.preferred_neighborhood}` : ""}
                      {r.move_date ? ` · moves ${r.move_date}` : ""}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    {r.lease_signed && <CheckCircle2 className="w-4 h-4 text-emerald-600" />}
                    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${STATUS_TONE[r.status] || "bg-slate-100 text-slate-700"}`}>{r.status_label}</span>
                    <ChevronRight className="w-4 h-4 text-slate-400" />
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
};
